import * as React from 'react';
import PropTypes from 'prop-types';

const SvgNavigationChallengeGroupGoalNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 25"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M20.158 4.251a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm1.269 15.417l1.012-7.393-6.699 3.299 1.241.893 2.483-1.222-4.943 6.862 1.095.789 4.947-6.866-.377 2.745 1.24.893zm-8.96-7.393l-1 7.385-1.241-.893.37-2.727-4.94 6.856-1.095-.79 4.946-6.866-2.48 1.224-1.241-.893 6.681-3.296zm-4-1.586l1-7.384L2.787 6.6l1.241.894 2.48-1.223-4.947 6.866 1.095.79 4.94-6.857-.37 2.726 1.241.893z"
        fill=""
      />
    </svg>
  )
);
SvgNavigationChallengeGroupGoalNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgNavigationChallengeGroupGoalNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgNavigationChallengeGroupGoalNormalSmall;
